import { ref, readonly } from "vue";
import axios from "axios";

export function useNewsTracking() {
  const isTracking = ref(false);
  const trackingErrors = ref([]);

  const trackNewsView = async (slug) => {
    if (isTracking.value) return;

    isTracking.value = true;

    try {
      const response = await axios.post(
        `/api/news/${slug}/view`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN":
              document
                .querySelector('meta[name="csrf-token"]')
                ?.getAttribute("content") || "",
          },
          timeout: 5000,
        }
      );

      if (response.data.success) {
        console.log("✅ View tracked:", response.data.formatted_view_count);

        // Clear any previous errors for this slug
        trackingErrors.value = trackingErrors.value.filter(
          (err) => err.slug !== slug
        );

        return {
          success: true,
          viewCount: response.data.view_count,
          formattedViewCount: response.data.formatted_view_count,
        };
      }
    } catch (error) {
      const errorInfo = {
        slug,
        message: "",
        timestamp: new Date().toISOString(),
      };

      if (error.response) {
        errorInfo.message =
          error.response.data.message ||
          `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorInfo.message = "Network error: No response from server";
      } else {
        errorInfo.message = `Request error: ${error.message}`;
      }

      trackingErrors.value.push(errorInfo);
      console.warn("⚠️ View tracking failed:", errorInfo.message);

      return {
        success: false,
        error: errorInfo.message,
      };
    } finally {
      isTracking.value = false;
    }
  };

  const clearErrors = () => {
    trackingErrors.value = [];
  };

  const getErrorsForSlug = (slug) => {
    return trackingErrors.value.filter((err) => err.slug === slug);
  };

  return {
    isTracking: readonly(isTracking),
    trackingErrors: readonly(trackingErrors),
    trackNewsView,
    clearErrors,
    getErrorsForSlug,
  };
}
